import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../reducers/types";
import { withRouter } from "react-router";
import { actions } from "../../actions";
import {
  getUntilDate,
  getFromDate,
  getNightCount,
  getAdultsCount,
  getChildrenCount,
} from "../../../search/reducer/selectors";
import {
  getPremierCollectionShopRoomInfoProducts,
  getPremierCollectionShopCallState,
  getPremierCollectionShopSelectedAvailability,
  getPremierCollectionShopChosenProduct,
  getPremierCollectionShopChosenRoomInfoIndex,
  getPremierCollectionShopChosenProductIndex,
  getPremierCollectionShopChosenRoomInfo,
} from "../../reducer/selectors";
import { DesktopRoomPicker } from "./component";
import { PremierCollectionShopCallState } from "../../reducer";
import {
  getSelectedAccountReferenceIdIfRedemptionEnabled,
  getSelectedAccount,
} from "../../../rewards/reducer";
import { isHotelCfarModelV1RefundableRoomUpdatedCopySelector } from "../../../ancillary/reducer/selectors";

const mapStateToProps = (state: IStoreState) => {
  const checkinDate = getFromDate(state);
  const checkoutDate = getUntilDate(state);
  const chosenRoomInfoIndex =
    getPremierCollectionShopChosenRoomInfoIndex(state);
  const chosenProductIndex = getPremierCollectionShopChosenProductIndex(state);
  const chosenRoomInfo = getPremierCollectionShopChosenRoomInfo(state);
  const chosenProduct = getPremierCollectionShopChosenProduct(state);
  const selectedLodging = getPremierCollectionShopSelectedAvailability(state);
  const nightCount = getNightCount(state);
  const rewardsKey =
    getSelectedAccountReferenceIdIfRedemptionEnabled(state) || undefined;
  const roomInfoProducts = getPremierCollectionShopRoomInfoProducts(state);
  const isPremierCollectionShopLoading =
    getPremierCollectionShopCallState(state) ===
    PremierCollectionShopCallState.InProcess;
  const adultsCount = getAdultsCount(state);
  const childrenCount = getChildrenCount(state);
  const isHotelCfarModelV1RefundableRoomUpdatedCopy =
    isHotelCfarModelV1RefundableRoomUpdatedCopySelector(state);
  const selectedRewardsAccount = getSelectedAccount(state);
  return {
    checkinDate,
    checkoutDate,
    chosenRoomInfoIndex,
    chosenProductIndex,
    chosenRoomInfo,
    chosenProduct,
    selectedLodging,
    nightCount,
    rewardsKey,
    roomInfoProducts,
    isPremierCollectionShopLoading,
    adultsCount,
    childrenCount,
    isHotelCfarModelV1RefundableRoomUpdatedCopy,
    selectedRewardsAccount,
  };
};

const mapDispatchToProps = {
  selectRoomType: actions.selectRoomType,
  fetchPremierCollectionShop: actions.fetchPremierCollectionShop,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type DesktopRoomPickerConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedDesktopRoomPickerPicker = withRouter(
  connector(DesktopRoomPicker)
);
